import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { PaymentMethod } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeletePaymentMethod = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("payment-methods", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Payment Method Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.PAYMENT_METHODS,
        (paymentMethods: PaymentMethod[] | undefined) => {
          return !paymentMethods
            ? []
            : deleteEntity<PaymentMethod>(paymentMethods, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Payment Method Deleting Error", { variant: "error" });
    },
  });
};
